module.exports = __webpack_public_path__ + "static/media/bg3.3a7496b7.png";